import { createFileRoute, redirect } from '@tanstack/react-router'
import { ResourcesPage } from '@unsw/features/resources'
import { getUserRole } from '@unsw/hooks'

export const Route = createFileRoute('/dashboard/resources')({
  beforeLoad: () => {
    const { isStudent } = getUserRole()
    if (!isStudent) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: ResourcesPage,
})
